import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  KeyboardArrowRight,
  KeyboardArrowDown,
  CalendarMonth,
} from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import { LeaveHistory } from "./LeaveHistory";
import { defaultAllSelection } from "services/constants";
import { customGetAPI } from "services/utils/CustomAPI";
import { themes, scrollTop } from "services/constants";
import { checkEditorPermission } from "services/utils/HelperFunction";
import TablePagination from "@mui/material/TablePagination";
import { essApplyLeave } from "services/constants";
import { PermissionsDetails } from "./permissionDetails";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { useDispatch } from "react-redux";
import Carousel from "react-grid-carousel";
import { getContrastingTextColor } from "services/utils/colorChecker";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { Loader } from "components/Loader";
import { tableRowSx } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";
const keys = [
  "date",
  "leave_type_name",
  "description",
  "credit",
  "debit",
  "createdby",
];

export const PastLeaveDetails = ({
  selectedUser,
  setReUpdatePastLeaveDetails,
  reUpdatePastLeaveDetails,
  taxYear,
  taxYearStartDate,
  taxYearEndDate,
  setSelectedUser,
  shiftId,
  handleClose,
  setCancelConfirmation,
  setCancelLeaveData,
}) => {
  const { token, domain, userDetails, globalSearchValue, userScreenAccess } =
    useSelector((state) => state.tokenReducer);
  const dispatch = useDispatch();
  const [taxYearStartDateUser, setTaxYearStartDate] =
    useState(taxYearStartDate);
  const [taxYearEndDateUser, setTaxYearEndDate] = useState(taxYearEndDate);
  const { result: leaveYears } = useFetch(`${domain}leaves-years/`);
  const [userUrl, setUserUrl] = useState("");
  const [leaveCreditDebitDetails, setLeaveCreditDebitDetails] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [leaveCreditDebitApi, setLeaveCreditDebitApi] = useState(false);
  const [leaveTypeTakenLeaves, setLeaveTypeTakenLeaves] = useState([]);
  const [currentScreen, setCurrentScreen] = useState("Leave Type");
  const [expandedRow, setExpandedRow] = useState(null);
  const [taxYearUser, setTaxYearUser] = useState(taxYear);
  const [singleLeaveTypeDetails, setSingleLeaveTypeDetails] = useState({});
  const [leavePage, setLeavePage] = useState(0);
  const [leaverowsPerPage, setLeaveRowsPerPage] = useState(25);
  const [pastLeaveDataSearchResults, setPastLeaveDataSearchResults] = useState(
    []
  );
  //updatedAPI
  const [getDataFromApi, setGetDataFromApi] = useState(true);
  const [totalPermission, setTotalPermission] = useState(0);
  const [loadPermissionApi, setLoadPersmissionApi] = useState(false);
  const [tagIndicator, setTagIndicator] = useState("Leaves");
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [leaveYear, setLeaveYear] = useState(null);
  const [leaveTypeDetail, setLeaveTypeDetail] = useState([]);
  const [leaveTypeId, setLeaveTypeId] = useState(shiftId);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (leaveYears.length !== 0) {
      setLeaveYear(leaveYears[0]?.name);
      setTaxYearStartDate(
        leaveYears[0]?.start_date.split("-").reverse().join("-")
      );
      setTaxYearEndDate(leaveYears[0]?.end_date.split("-").reverse().join("-"));
      setLeaveYear(
        leaveYears[0]?.start_date + " To " + leaveYears[0]?.end_date
      );
      setGetDataFromApi(true);
      setLoadPersmissionApi(true);
    }
  }, [leaveYears]);

  useEffect(() => {
    const updateLeaveDetails = async () => {
      const sortedLeaveRequests = leaveTypeTakenLeaves?.sort(
        (a, b) => new Date(b.from_date) - new Date(a.from_date)
      );
      setPastLeaveDataSearchResults(sortedLeaveRequests);
      setMasterDataForSearch(sortedLeaveRequests);
    };
    if (reUpdatePastLeaveDetails) {
      updateLeaveDetails();
      setReUpdatePastLeaveDetails(false);
    }
  }, [
    leaveTypeTakenLeaves,
    reUpdatePastLeaveDetails,
    selectedUser.leave_requests,
    setReUpdatePastLeaveDetails,
  ]);

  const handleChangeLeavePage = (event, newPage) => {
    setLeavePage(newPage);
  };

  const handleChangeLeaveRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return "primary";
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      case "Rejected":
        return "error";
      case "cancel":
        return "error";
      default:
        return "default";
    }
  };

  useEffect(() => {
    const filteredResults = masterDataForSearch?.filter((item) =>
      essApplyLeave.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setPastLeaveDataSearchResults(filteredResults);
    setLeavePage(0);
  }, [globalSearchValue, masterDataForSearch]);

  useEffect(() => {
    const getUserDetails = async () => {
      const res = await customGetAPI(
        `${domain}leave-summary-history/?user_id=${selectedUser?.user_id}&start_date=${taxYearStartDateUser}&end_date=${taxYearEndDateUser}`
      );
      if (res.ok) {
        setMasterData(res?.responseDetails);
        setLeaveCreditDebitApi(false);
        setLoading(false);
      } else {
        setLoading(false);
        setLeaveCreditDebitApi(false);
      }
    };
    if (
      leaveCreditDebitApi &&
      tagIndicator === "Leave History" &&
      taxYearStartDateUser &&
      taxYearEndDateUser
    ) {
      setLoading(true);
      getUserDetails();
    }
  }, [
    domain,
    leaveCreditDebitApi,
    selectedUser?.user_id,
    tagIndicator,
    taxYearEndDateUser,
    taxYearStartDateUser,
  ]);

  useEffect(() => {
    const getUserDetails = async () => {
      const res = await customGetAPI(
        `${domain}leave-summary-details/?user_id=${selectedUser?.user_id}&start_date=${taxYearStartDateUser}&end_date=${taxYearEndDateUser}`
      );
      if (res.ok) {
        setLeaveTypeTakenLeaves(
          res?.responseDetails ? res?.responseDetails[0]?.leave_requests : []
        );
        setUserUrl(
          res?.responseDetails ? res?.responseDetails[0]?.image_url : ""
        );
        setLeaveTypeDetail(res?.responseDetails);
        setLeaveTypeId(
          res?.responseDetails ? res?.responseDetails[0]?.leave_type_id : 0
        );
        setSingleLeaveTypeDetails(
          res?.responseDetails ? res?.responseDetails[0] : []
        );
        setReUpdatePastLeaveDetails(true);
        setLoading(false);
        setGetDataFromApi(false);
      } else {
        setLoading(false);
        setGetDataFromApi(false);
      }
    };
    if (
      getDataFromApi &&
      tagIndicator === "Leaves" &&
      taxYearStartDateUser &&
      taxYearEndDateUser
    ) {
      setLoading(true);
      getUserDetails();
    }
  }, [
    domain,
    getDataFromApi,
    selectedUser?.user_id,
    setSelectedUser,
    leaveTypeId,
    taxYearEndDateUser,
    taxYearStartDateUser,
    token,
    tagIndicator,
    userDetails.id,
    setReUpdatePastLeaveDetails,
  ]);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [leavePage]);

  useEffect(() => {
    const filteredResults = masterData?.filter((item) =>
      keys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setLeaveCreditDebitDetails(filteredResults);
  }, [globalSearchValue, masterData]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <BackArrow
          actionFunction={() => {
            dispatch(setGlobalSearchValue(""));
            handleClose();
          }}
        />
        <Mui.Typography
          sx={{
            paddingTop: 1,
            fontSize: 23,
            fontWeight: "bold",
            color: themes.headLine,
            paddingLeft: 1,
          }}
        >
          Leave Summary / Leave Details
        </Mui.Typography>
      </Mui.Grid>
      <Mui.Grid container sx={{ paddingTop: 1, paddingBottom: 1 }}>
        <Mui.Grid
          xs={6}
          md={6}
          lg={3}
          sm={6}
          sx={{
            paddingTop: 1,
            backgroundColor: themes.primary,
            paddingBottom: 1,
          }}
        >
          <Mui.Grid container>
            <Mui.Stack direction="row">
              <Mui.Avatar
                sx={{
                  width: 50,
                  height: 50,
                  marginLeft: 5,
                  backgroundColor: "#ff4d88",
                }}
                alt={selectedUser?.user_name.charAt(0).toUpperCase()}
                src={userUrl}
              />
              <Mui.Stack direction="column" sx={{ paddingLeft: 2 }}>
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={selectedUser?.user_name}
                >
                  <Mui.Typography
                    sx={{
                      fontWeight: "bold",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                    }}
                  >
                    {selectedUser?.user_name}
                  </Mui.Typography>
                </Mui.Tooltip>
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title={selectedUser?.role}
                >
                  <Mui.Typography
                    sx={{
                      fontWeight: "bold",
                      color: themes?.dividerBorder,
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                    }}
                  >
                    {selectedUser?.role}
                  </Mui.Typography>
                </Mui.Tooltip>
              </Mui.Stack>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid lg={6.3}></Mui.Grid>
        <Mui.Grid xs={4.5} md={4.5} lg={2.5} sm={4.5}>
          <Mui.Autocomplete
            disablePortal
            id="combo-box-demo"
            size="small"
            value={leaveYear}
            options={leaveYears.map((obj) => ({
              ...obj,
              label: obj.name,
              yearDate: obj.start_date + " To " + obj.end_date,
            }))}
            sx={{ width: "100%", marginTop: -2 }}
            filterOptions={(options, state) => {
              return options.filter((option) =>
                option.label
                  .toLowerCase()
                  .includes(state.inputValue.toLowerCase())
              );
            }}
            renderOption={(props, option) => {
              return <li {...props}>{option.label}</li>;
            }}
            ListboxProps={{
              style: {
                maxHeight: 150,
              },
            }}
            onChange={(event, value) => {
              if (value) {
                setTaxYearUser(value.label);
                setTaxYearStartDate(
                  value.start_date.split("-").reverse().join("-")
                );
                setTaxYearEndDate(
                  value.end_date.split("-").reverse().join("-")
                );
                setGetDataFromApi(true);
                setLoadPersmissionApi(true);
                setLeaveCreditDebitApi(true);
                setLeaveYear(value.yearDate);
              }
            }}
            renderInput={(params) => (
              <Mui.TextField
                {...params}
                label={taxYearUser}
                sx={{ background: themes.whiteColor }}
                placeholder="Select the leave period"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <CalendarMonth
                        style={{ margin: "0 8px", color: "#a6a6a6" }}
                      />
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Mui.Grid>
      </Mui.Grid>
      {/* Menu Start */}
      <Mui.Grid container sx={{ padding: 1 }}>
        <Mui.Grid xs={1.5}></Mui.Grid>
        <Mui.Grid
          xs={3}
          sx={{
            padding: 1,
            backgroundColor:
              currentScreen === "Leave Type" ? themes.headLine : themes.primary,
            cursor: "pointer",
          }}
          onClick={() => {
            setCurrentScreen("Leave Type");
            // setPermissionId(null);
            setLeaveTypeId(defaultAllSelection);
            setTagIndicator("Leaves");
            setGetDataFromApi(true);
          }}
        >
          <Mui.Typography
            sx={{
              fontWeight: "bold",
              color:
                currentScreen === "Leave Type"
                  ? themes.whiteColor
                  : themes.headLine,
              textAlign: "center",
            }}
          >
            Leave Type
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid
          xs={3}
          sx={{
            padding: 1,
            backgroundColor:
              currentScreen === "Permission" ? themes.headLine : themes.primary,
            cursor: "pointer",
          }}
          onClick={() => {
            setCurrentScreen("Permission");
            setLeaveTypeId("");
            dispatch(setGlobalSearchValue(""));
            setTagIndicator("Permissions");
            setLoadPersmissionApi(true);
          }}
        >
          <Mui.Typography
            sx={{
              fontWeight: "bold",
              color:
                currentScreen === "Permission"
                  ? themes.whiteColor
                  : themes.headLine,
              textAlign: "center",
            }}
          >
            Permission
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid
          xs={3}
          sx={{
            padding: 1,
            backgroundColor:
              currentScreen === "Leave History"
                ? themes.headLine
                : themes.primary,
            cursor: "pointer",
          }}
          onClick={() => {
            setCurrentScreen("Leave History");
            setTagIndicator("Leave History");
            setLeaveCreditDebitApi(true);
          }}
        >
          <Mui.Typography
            sx={{
              fontWeight: "bold",
              color:
                currentScreen === "Leave History"
                  ? themes.whiteColor
                  : themes.headLine,
              textAlign: "center",
            }}
          >
            Leave History
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid xs={1.5}></Mui.Grid>
      </Mui.Grid>
      {/* Menu End */}
      <Mui.Grid sx={{ padding: 2 }}></Mui.Grid>
      {currentScreen === "Leave Type" ? (
        <Carousel
          cols={4}
          rows={1}
          gap={20}
          responsiveLayout={[
            {
              breakpoint: 800,
              cols: 3,
              rows: 1,
              gap: 10,
              loop: true,
              autoplay: 1000,
            },
          ]}
          autoplay={30000}
          loop={true}
        >
          {leaveTypeDetail?.map((ltdet) => (
            <Carousel.Item>
              <Mui.Card
                sx={{
                  backgroundColor:
                    ltdet?.leave_type_id === 99999
                      ? themes.primaryIndicator
                      : ltdet?.leave_color,
                  justifyContent: "center",
                  alignContent: "center",
                  height: leaveTypeId === ltdet?.leave_type_id ? "10vh" : "8vh",
                  marginTop: leaveTypeId === ltdet?.leave_type_id ? 0 : 2,
                  cursor: "pointer",
                  borderRadius: 2,
                  marginBottom: 1,
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  overflow: "hidden",
                }}
                onClick={() => {
                  setLeaveTypeId(ltdet?.leave_type_id);
                  setLeaveTypeTakenLeaves(ltdet?.leave_requests || []);
                  setTagIndicator("Leaves");
                  setReUpdatePastLeaveDetails(true);
                  setSingleLeaveTypeDetails(ltdet);
                }}
              >
                <Mui.Typography
                  sx={{
                    color: getContrastingTextColor(
                      leaveTypeId === ltdet?.leave_type_id
                        ? themes.primaryIndicator
                        : themes.lightGray
                    ),
                    justifyContent: "center",
                    alignContent: "center",
                    display: "flex",
                    fontWeight: 700,
                    fontSize: 18,
                  }}
                >
                  {ltdet?.name}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    color: getContrastingTextColor(
                      leaveTypeId === ltdet?.leave_type_id
                        ? themes.primaryIndicator
                        : themes.lightGray
                    ),
                    justifyContent: "center",
                    alignContent: "center",
                    display: "flex",
                    fontWeight: 500,
                    fontSize: 16,
                  }}
                >
                  {ltdet?.available_leave}
                </Mui.Typography>
              </Mui.Card>
            </Carousel.Item>
          ))}
        </Carousel>
      ) : null}
      {tagIndicator !== "Leave History" ? (
        <Mui.Box
          sx={{
            marginTop: 2,
            boxShadow: 3,
            display: "flex",
            flexDirection: "row",
            ml: 2,
            mr: 2,
            p: 2,
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? themes.primary : themes.primary,
            color: (theme) =>
              theme.palette.mode === "dark" ? "grey.300" : "grey.800",
            border: "1px solid",
            borderColor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.300",
            borderRadius: 2,
            fontSize: "0.875rem",
            fontWeight: "700",
          }}
        >
          {tagIndicator === "Leaves" ? (
            <>
              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center", borderRight: "1px solid black" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Annual Allowance <br />
                  {singleLeaveTypeDetails?.annual_allowance || 0} days
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center", borderRight: "1px solid black" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Total Credited <br />
                  {singleLeaveTypeDetails?.credited_leave || 0} days{" "}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center", borderRight: "1px solid black" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Planned
                  <br />
                  {singleLeaveTypeDetails?.planned_leave || 0} days{" "}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center", borderRight: "1px solid black" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Used <br />
                  {singleLeaveTypeDetails?.used_leave || 0} days{" "}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center", borderRight: "1px solid black" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Balance <br />
                  {singleLeaveTypeDetails?.available_leave || 0} days
                </Mui.Typography>
              </Mui.Grid>

              <Mui.Grid
                xs={12}
                sm={12}
                md={2}
                lg={2}
                sx={{ textAlign: "center" }}
              >
                <Mui.Typography sx={{ color: themes.headLine, fontSize: 18 }}>
                  Expiry Date <br />
                  {singleLeaveTypeDetails?.expiry_date || "N/A"}
                </Mui.Typography>
              </Mui.Grid>
            </>
          ) : tagIndicator === "Permissions" ? (
            <>
              <Mui.Grid xs={12} sx={{ textAlign: "center" }}>
                <Mui.Typography>
                  <span
                    style={{
                      color: themes.headLine,
                      fontSize: 18,
                    }}
                  >
                    <span
                      style={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      {totalPermission} &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    Permissions Taken
                  </span>
                </Mui.Typography>
              </Mui.Grid>
            </>
          ) : null}
        </Mui.Box>
      ) : null}
      {tagIndicator === "Leaves" && !loading ? (
        <Mui.Grid container>
          <Mui.TableContainer
            ref={containerRef}
            sx={{
              height: "100%",
              overflowY: "auto",
              marginTop: 2,
              marginLeft: "auto",
              marginRight: "auto",
              minWidth: "90%",
              maxWidth: "100%",
              ml: 2,
              mr: 2,
            }}
            className="w-96 border  rounded "
          >
            <Mui.Table className="border">
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                }}
              >
                <Mui.TableRow sx={tableRowSx}>
                  <Mui.TableCell className="column-cell"></Mui.TableCell>
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight={"bold"}>
                      Leave Type
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight={"bold"}>
                      Start Date
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight={"bold"}>
                      End Date
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight={"bold"}>
                      Business days
                    </Mui.Typography>
                  </Mui.TableCell>
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight={"bold"}>Status</Mui.Typography>
                  </Mui.TableCell>
                  {/* {userDetails.id === parseInt(selectedUser?.user_id) ? ( */}
                  <Mui.TableCell className="column-cell">
                    <Mui.Typography fontWeight="bold">Action</Mui.Typography>
                  </Mui.TableCell>
                  {/* ) : null} */}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {pastLeaveDataSearchResults?.length === 0 ? (
                  <InfoMessage dataLength={masterDataForSearch} />
                ) : (
                  pastLeaveDataSearchResults
                    ?.slice(
                      leavePage * leaverowsPerPage,
                      leavePage * leaverowsPerPage + leaverowsPerPage
                    )
                    .map((leave) => (
                      <>
                        <Mui.TableRow key={leave.id} sx={tableRowSx}>
                          <Mui.TableCell className="column-cell">
                            {expandedRow === leave.id ? (
                              <Mui.IconButton
                                onClick={() => {
                                  setExpandedRow(null);
                                }}
                              >
                                <KeyboardArrowDown
                                  style={{
                                    color: themes.headLine,
                                    fontWeight: "bold",
                                  }}
                                />
                              </Mui.IconButton>
                            ) : (
                              <Mui.IconButton
                                onClick={() => handleRowClick(leave.id)}
                              >
                                <KeyboardArrowRight
                                  style={{
                                    color: themes.headLine,
                                    fontWeight: "bold",
                                  }}
                                />
                              </Mui.IconButton>
                            )}
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            {leave.name}
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            {leave.from_date}
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            {leave.to_date}
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            <Mui.Typography variant="body1" gutterBottom>
                              {leave.business_days}
                            </Mui.Typography>
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            {leave.status}
                          </Mui.TableCell>
                          <Mui.TableCell className="column-cell">
                            {!leave.is_cancel_enabled ||
                            (leave.status !== "Approved" &&
                              leave.status !== "Pending") ? (
                              <Mui.Tooltip
                                arrow
                                slotProps={tooltipStyleProps}
                                title={
                                  !leave?.is_cancel_enabled
                                    ? "Payroll Submitted. Not able to edit"
                                    : ""
                                }
                              >
                                <span>
                                  <Mui.Button
                                    sx={{ borderRadius: 3 }}
                                    variant="contained"
                                    color={getStatusColor("cancel")}
                                    className="cancel-button"
                                    onClick={() => {
                                      if (
                                        checkEditorPermission(
                                          userScreenAccess?.module_details,
                                          "Leave Summary",
                                          "Leavesummary"
                                        )
                                      ) {
                                        setCancelLeaveData(leave);
                                        setCancelConfirmation(true);
                                      } else {
                                        showToast(
                                          "error",
                                          "Access denied: You are not authorized to cancel the leave"
                                        );
                                      }
                                    }}
                                    disabled
                                  >
                                    Cancel
                                  </Mui.Button>
                                </span>
                              </Mui.Tooltip>
                            ) : (
                              <Mui.Button
                                sx={{ borderRadius: 3 }}
                                variant="contained"
                                color={getStatusColor("cancel")}
                                className="cancel-button"
                                onClick={() => {
                                  if (
                                    checkEditorPermission(
                                      userScreenAccess?.module_details,
                                      "Leave Summary",
                                      "Leavesummary"
                                    )
                                  ) {
                                    setCancelLeaveData(leave);
                                    setCancelConfirmation(true);
                                  } else {
                                    showToast(
                                      "error",
                                      "Access denied: You are not authorized to cancel the leave"
                                    );
                                  }
                                }}
                              >
                                Cancel
                              </Mui.Button>
                            )}
                          </Mui.TableCell>
                        </Mui.TableRow>
                        {expandedRow === leave.id && (
                          <Mui.TableRow sx={tableRowSx}>
                            <Mui.TableCell colSpan={12}>
                              <Mui.TableContainer
                                sx={{
                                  marginTop: 0,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  width: "100%px",
                                }}
                                className="w-96 border rounded"
                              >
                                <Mui.Table className="border">
                                  <Mui.Typography
                                    variant="body1"
                                    gutterBottom
                                    sx={{ marginLeft: 1, marginTop: 1 }}
                                  >
                                    <strong>Description :</strong>{" "}
                                    <Mui.Typography
                                      fontSize={15}
                                      color="textSecondary"
                                      sx={{ marginLeft: 13 }}
                                    >
                                      {leave.description}
                                    </Mui.Typography>
                                  </Mui.Typography>
                                </Mui.Table>
                              </Mui.TableContainer>
                              {leave.status === "Rejected" ? (
                                <Mui.TableContainer
                                  sx={{
                                    marginTop: 0.5,
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    width: "100%px",
                                  }}
                                  className="w-96 border rounded"
                                >
                                  <Mui.Table className="border">
                                    <Mui.Typography
                                      variant="body1"
                                      gutterBottom
                                      sx={{ marginLeft: 1, marginTop: 1 }}
                                    >
                                      <strong>Reason for Rejection :</strong>{" "}
                                      <Mui.Typography
                                        fontSize={15}
                                        color="textSecondary"
                                        sx={{ marginLeft: 13 }}
                                      >
                                        {leave.reason}
                                      </Mui.Typography>
                                    </Mui.Typography>
                                  </Mui.Table>
                                </Mui.TableContainer>
                              ) : null}
                            </Mui.TableCell>
                          </Mui.TableRow>
                        )}
                      </>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>

            {pastLeaveDataSearchResults?.length > 25 ? (
              tagIndicator === "Leaves" ? (
                <TablePagination
                  sx={{ marginRight: 7 }}
                  className="custom-pagination"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={pastLeaveDataSearchResults?.length}
                  rowsPerPage={leaverowsPerPage}
                  page={leavePage}
                  onPageChange={handleChangeLeavePage}
                  onRowsPerPageChange={handleChangeLeaveRowsPerPage}
                />
              ) : null
            ) : null}
          </Mui.TableContainer>
        </Mui.Grid>
      ) : loading ? (
        <Loader info="Loading..." />
      ) : tagIndicator === "Leave History" ? (
        <LeaveHistory leaveCreditDebitDetails={leaveCreditDebitDetails} />
      ) : (
        <PermissionsDetails
          selectedUser={selectedUser}
          loadPermissionApi={loadPermissionApi}
          setLoadPersmissionApi={setLoadPersmissionApi}
          setTotalPermission={setTotalPermission}
          taxYearStartDateUser={taxYearStartDateUser}
          taxYearEndDateUser={taxYearEndDateUser}
          masterData={masterData}
        />
      )}
    </React.Fragment>
  );
};
